// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2s_Fq","App-logo":"App_App-logo__1OUG0","App-header":"App_App-header__3TyHG","App-link":"App_App-link__1zUGJ"};